/**
 * Vendor scripts entry point
 */
import "./jquery-global";

import "jquery-easing";

import "eqcss";

import enquire from "../../../node_modules/enquire.js/dist/enquire.js";
window.enquire = enquire;

import store from "store";
window.store = store;

import "jquery-resizable-columns";

import "awesomplete";

import flatpickr from "flatpickr";
window.flatpickr = flatpickr;
import "flatpickr/dist/l10n/de.js";

import "./input-stepper/jquery.input-stepper";

import "select2";

import Quill from "quill";
window.Quill = Quill;

import Pickr from "@simonwep/pickr";
window.Pickr = Pickr;

import "ion-rangeslider";
